var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-button"},[_c('div',{staticClass:"item-button-icon",style:(_vm.itemStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }